angular.module('unica_archive_media.archive_media_controllers', [])

.controller('ArchiveMediaBasicController',
	function(
		$rootScope, $scope, $stateParams,
		FileUploader, getBaseApiURL, Session
	) {

	$scope.forms = {};

	$scope.uploader =  new FileUploader({
		removeAfterUpload: true,
		alias: 'files',
		url: getBaseApiURL + '/event/upload-media',
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$rootScope.mediaData = {
		event_id: $stateParams.event_id,
		files: []
	};


});


